import { ActionIcon, Center, Grid, Group, Title } from '@mantine/core'
import React from 'react'
import RolesSelect from '../components/roles_select'
import { useAuth } from '../contexts/auth.context'
import { FaSignOutAlt } from 'react-icons/fa';

export default function DownloadAppPage(){
    const { logout } = useAuth();
    return <div>
        <Group>
            <div style={{flex: 1}}>
                <RolesSelect />
            </div>
            <ActionIcon
                onClick={() => { logout(); }}
                ml="xs"
                size="lg"
                color="orange"
              ><FaSignOutAlt /></ActionIcon>
        </Group>

        <Center style={{ width: "100vw", minHeight: "100vh", position: 'relative', background: `linear-gradient(to top right, #ff7400, #ff7400, #ff7400)` }}>
            <Grid style={{margin: 0}}>
                <Grid.Col span={12} style={{paddingTop: 60}}>
                    <Title align='center' color="white">Baixe o app e acesse agora mesmo!</Title>
                </Grid.Col>
                <Grid.Col span={12} >
                </Grid.Col>
                <Grid.Col span={6} style={{textAlign: 'center'}}>
                    <a target='_blank' href='https://play.google.com/store/apps/details?id=br.com.satify.app&hl=pt_BR&gl=US'><img src="/download-google.svg" style={{width: '80%'}} /></a>
                </Grid.Col>
                <Grid.Col span={6} style={{textAlign: 'center'}}>
                    <a target='_blank' href='https://apps.apple.com/br/app/whatsapp-messenger/id6470944430'><img src="/download-apple.svg" style={{width: '80%'}} /></a>
                </Grid.Col>
            </Grid>
        </Center>
    </div>
}